<template>
  <div class="rt-input-money">
    <el-input
      type="text"
      :placeholder="placeholder"
      :readonly="readonly"
      :disabled="disabled"
      v-model="text"
      @focus="focus"
      @blur="blur"
    >
      <span slot="prefix" class="prefix">
        <slot name="prefix" />
      </span>
    </el-input>
    <rt-icon name="rt-base-edit" color="#a9c2e8" v-if="!disabled" />
  </div>
</template>

<script>
import inputFocusMixins from './inputFocusMixins.js';
export default {
  name: 'RtInputMoney',
  mixins: [inputFocusMixins],
  props: {
    placeholder: {
      type: String,
      default() {
        return this.$tx('暂无', 'xpc.input.novalue');
      },
    },
    value: [String, Number],
    datafieldname: String,
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    precision: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      text: this.$dealThousands(this.value, this.precision),
    };
  },
  methods: {
    focus() {
      this.text = this.value;
    },
    blur() {
      this.text = this.$dealThousands(this.text, this.precision);
      let val = this.strToNumber(this.text);
      let valArr = val.split('.');
      if (this.precision == 2 && valArr[1]==='00') {
        val = valArr[0]
      }
      this.$emit('input', val);
    },
    strToNumber(obj) {
      var reg = /^[0-9]+.?[0-9]*$/; //验证字符串是否是数字
      if (!reg.test(obj)) {
        //为字符串 则判断是否存在','
        if ((obj + '').replace(/^\s\s*/, '').replace(/\s\s*$/, '') == '') {
          return '';
        }
        if (obj == undefined) {
          return '';
        }
        if ((obj || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')) {
          obj = obj.replace(/,/gi, '');
          return obj;
        }
      }
      return obj;
    },
  },
};
</script>

<style lang="less" scoped>
@deep: ~'>>>';
.rt-input-money {
  display: flex;
  align-items: center;
  position: relative;
  span {
    color: #a9c2e8;
  }
  input {
    width: 100%;
    height: 28px;
    font-size: 14px;
    padding: 0 24px 0 8px;
    color: #143e81;
  }
  .rt-icon {
    position: absolute;
    right: 0;
  }
  .prefix {
    color: #143e81;
  }
}
</style>



// WEBPACK FOOTER //
// rtInputMoney.vue?53f1afa0